export default {
  helloWorld: 'Bonjour le monde !',
  routes: {
    pathPrefix: 'fr',
    basePath: 'assurance-automobile/formulaire-de-demande',
    motorbikeBasePath: 'assurance-moto/formulaire-de-demande',
    insuranceRequest: '',
    agent: 'agent',
    productSelect: 'prime',
    options: 'modification-des-couvertures',
    vehicleSelect: 'recherche-du-vehicule',
    vehicleSelectComfort: 'confort',
    vehicleSelectVehicleNumber: 'numero-de-reception-par-type',
    vehicleSelected: 'selection-du-vehicule',
    vehicleData: 'donnees-du-vehicule',
    owner: 'detenteur',
    personalData: 'donnees-personnelles',
    checkout: 'verification-des-donnees',
    offer: 'demander-une-offre',
    referral: 'references',
    renewal: 'renewal',
    confirmation: 'confirmation',
    infoLater: 'infos-tard',
    finish: 'complet',
    declined: 'refus',
    rejected: 'en-cours-de-traitement',
    offerExpired: 'expire',
    error: 'fautes',
    maintenance: 'entretien',
    playground: 'cours-de-recreation',
    offerten_vorschlag: 'proposition_offre',
  },
  errors: {
    graphqlQueryBase: 'Une erreur s\´est produite. Veuillez réessayer.',
    paper: 'sous forme papier',
    electronic: 'éléctronique',
    vehicleNotFound: 'Véhicule non trouvé. Veuillez vérifier votre saisie ou utiliser la recherche de véhicule.',
    technicalError: 'Une erreur technique s’est produite. Veuillez essayer à nouveau.',
    technicalErrorLater: "Une erreur technique s'est produite. Un certain temps sera nécessaire pour qu’il puisse être résolue. Veuillez réessayer le calcul plus tard.",
    maintenance: 'Le système est actuellement en mode de maintenance. Veuillez réessayer le calcul plus tard.',
    declined: 'Malheureusement, nous ne pouvons pas vous offrir une assurance pour votre véhicule pour le moment.',
  },
  basics: {
    age: 'Année',
    plz: 'Code postal',
    gender: 'Titre',
    genderFemale: 'Madame',
    genderMale: 'Monsieur',
    genderCompany: 'Entreprise',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    street: 'Nom de la Rue',
    houseNumber: 'Numéro de la Rue',
    city: 'Localité',
    email: 'E-mail',
    phone: 'Numéro de téléphone',
    dateOfBirth: 'Date de naissance',
    licence: 'Permis de conduire    ',
    nationality: 'Nationalité',
    swiss: 'Suisse',
    others: 'Autres',
    chooseOption: 'Veuillez sélectionner',
    noResultsOption: 'Aucun résultat',
    unknownOption: 'Je ne sais pas ce que c\´est.',
    selectProduct: 'Choisir le produit',
    customizeCoverage: 'Modifier les couvertures',
    vehicle: 'Véhicule',
    ovner: 'Détenteur',
    enterContract: 'Conclure',
    continue: 'suivant',
    back: 'retour',
    reset: 'Données supprimées',
    yes: 'Oui',
    no: 'Non',
    notWanted: 'pas souhaité',
    datePlaceholder: 'JJ.MM.AAAA',
    yearPlaceholder: 'AAAA',
    company: 'Nom de l\´entreprise',
    uid: 'Numéro d\´identification de l\´entreprise',
    industry: 'Branche',
    vehicleType: 'Type du véhicule',
    flexDrive: 'FlexDrive',
    basisDrive: 'BasisDrive',
  },

  start: {
    head: {
      h1: 'Votre nouvelle assurance automobile',
      h3: 'Calculez dès maintenant votre prime d’assurance véhicule',
      p: 'Des produits à la pointe, entièrement numérique et un conseil soigné et personnel – C’est cela Simpego.',
      list: {
        car: 'Voiture de tourisme',
        van: 'Voiture de livraison',
        vanRegisteredAsCar: "Voiture d'entreprise",
        motorbike: 'Moto',
      },
    },
    form: {
      personal: {
        h3: 'Données personnelles',
        age1: 'J\'ai',
        age2: 'ans.',
        plz1: 'Mon code postal est',
        otherNationality: 'Autres nationalités',
        customerTypePerson: 'Clientèle privée',
        customerTypeCompany: 'Clientèle entreprise',
        companyZip: 'Code postale de l\´entreprise',
        industry: 'Branche de l\´entreprise',
        industries: {
          industry1: 'Commerce, finance, conseil, immobilier, IT',
          industry2: 'Hôtels et restaurants, tourisme et voyages, loisirs',
          industry3: 'Construction, ateliers, contrauction mécanique',
          industry4: 'Production, élimination, nettoyage',
          industry5: 'Poste, messagerie, service de livraison, industrie du transport',
          industry6: 'Marine et aviation',
          industry7: 'Location de véhicules',
          industry8: 'Soins médicaux, à domicile, services vétérinaires',
          industry9: 'Musique, Médias, Édition, TV, Publicité',
          industry10: 'institutions publiques, musées, églises, associations',
          industry11: 'Agriculture, Eau, Energie, Chimie',
          industry12: 'autorités compétentes',
          industry13: 'divers',
        },
        ageOrYear: 'Année / Année de naissance',
        zip: 'Code postal',
      },
      car: {
        h3: 'Données du véhicule',
        searchmode1: 'Rechercher le véhicule',
        searchmode2: 'Recherche avec le numéro de réception par type du véhicule',
        initialRegistrationYear: '1ère mise en circulation',
        brand: 'La marque de mon véhicule est',
        model: 'Le modèle est',
        fuelType: 'Le type de carburant du véhicule (Carburant)',
        powerRange: 'La puissance s\´élève à  (PS)',
        typeCertificateNumber: 'Le numéro de réception par type est ',
        typeCertificateNumber_placeholder: 'Paragraphe 24 du permis de circulation',
        vehicleSearchError: 'Désolé, votre recherche n\´a donné aucun résultat.',
      },
      startOfInsurance: {
        h3: 'Début de l’assurance',
        startOfInsurance: 'Date de début de l’assurance',
      },
      sendButton: 'Aperçu des primes',
    },
  },
  insurancerequest: {
    annoPrice: '/ an',
    from: 'à partir de',
    footerBackText: 'recalculer ',
    declinedHeadline: "Le calcul du prix n'est pas possible. Raison:",
  },
  customizeCoverage: {
    form: {
      deductible: {
        h3: 'Responsabilité civile ',
        h3Hint: "Assurance responsabilité civile obligatoire : Simpego couvre les dommages matériels causés à des tiers (par exemple, des véhicules) et corporels causés à des personnes en tant que propriétaire ou conducteur de votre véhicule. Nous assumons les prétentions légitimes et la défense des prétentions en matière de responsabilité civile qui ont été soulevées à tort. Ceci s'applique aux situations suivantes:<br><br> - causés par la conduite du véhicule;<br> - en cas d'accidents de la circulation causés par le véhicule lorsqu'il n'est pas en marche;<br> - en cas d'assistance après un accident impliquant le véhicule;<br> - lors de la montée et de la descente du véhicule, de l'ouverture et de la fermeture des parties mobiles du véhicule et de la fixation ou de l'enlèvement de remorques et véhicules.<br><br> Simpego paie les réclamations non fondées et les indemnise pour la personne assurée. Les prestations sont limitées à CHF 100 millions par événement, y compris les intérêts sur les dommages-intérêts, les honoraires d'avocats et les frais de justice. Franchises pour les conducteurs de moins de 25 ans : M plus CHF 1\´500, L plus CHF 1\´200 et XL plus CHF 1\´000.",
        customizeCoverage: {
          label: 'Franchise en CHF',
          infoText: 'Choisissez votre franchise individuelle. Vous payez vous-même ce montant en cas de sinistre.',
          inputHint: 'Saisissez une valeur comprise entre CHF {min} - {max}',
        },
        customizeCoverage25: {
          label: 'Franchise pour les conducteurs non déclarés jusqu\´à 25 ans',
          infoText: 'Cette franchise n\´est pas appliquée si le conducteur déclaré a moins de 25 ans ou si en tant que conducteur vous avez moins de 25 ans.',
          value: '+ CHF {value}',
        },
        fieldName: 'Franchise',
      },
      comprehensive: {
        h3: 'Casco',
        comprehensiveOptions: {
          label: 'Choisir le type de casco',
          infoText: 'Assurance casco complète (casco partielle- et assurance casco collision). <br><br> En plus de toutes les prestations de l\´assurance casco partielle, les dommages causés par un impact soudain, violent, mécanique, involontaire ou externe, tel qu\´un choc, une collision, un accident ou un renversement, sont assurés.<br><br>Les dommages causés par le feu, les risques naturels, les glissements de neige, le vol, la collision avec un animal, les dommages causés par la martre, le bris de vitre, le vandalisme et les dommages causés par l\´écrasement d\´un aéronef et d\´un engin spatial ou de leurs pièces, ainsi que l\´atterrissage de secours sont couverts.',
        },
        partially_comprehensive: {
          label: 'Franchise casco partielle en CHF',
          infoText: 'Choisissez votre franchise individuelle. Vous payez vous-même ce montant en cas de sinistre.',
          inputHint: 'Saissisez une valeur entre CHF {min} - {max}',
        },
        fully_comprehensive: {
          label: 'Franchise casco collision en CHF',
          infoText: 'Choisissez votre franchise individuelle. Vous payez vous-même ce montant en cas de sinistre.',
          inputHint: 'Saissisez une valeur entre CHF {min} - {max} an',
        },
        deductible_under_25: {
          label: 'Franchise casco collision pour les conducteurs non déclarés jusqu´à 25 ans',
          infoText: 'Cette franchise n´est pas appliquée si le conducteur déclaré a moins de 25 ans ou si en tant que conducteur vous avez moins de 25 ans.',
          value: '+ CHF {value}',
        },
      },
      comprehensiveOptions: {
        h3: 'Couvertures complémentaires en Casco',
        park_damage: {
          label: 'Dommages au véhicule parqué',
          infoText: "Dommages de parc Basic<br>Les dommages causés au véhicule stationné par des personnes inconnues sont assurés jusqu'à concurrence de CHF 2´000.- par sinistre, en tenant compte de la franchise choisie.<br><br>Dommages au stationnement Plus<br>Les dommages au véhicule stationné causés par des tiers inconnus sont assurés en tenant compte de la franchise choisie et sans limite.<br><br>L'assurance couvre un maximum de 2 sinistres par année civile.",
        },
        park_damage_deductible: {
          label: 'Franchise pour dommages au véhicule parqué en CHF',
          infoText: 'Choisissez votre franchise individuelle. Vous payez vous-même ce montant en cas de sinistre. La franchise de la couverture de dommages de parc doit être inférieure à la franchise de l\´assurance dommages collision.',
          inputHint: 'Saisissez une valeur comprise entre CHF {min} - {max}',
        },
        free_garage: {
          label: 'Convention de réparation en cas de sinistre',
          infoText: "Convention de réparation Garage partenaire<br><br>Vous vous engagez à nous déclarer votre sinistre casco avant d’effectuer les réparations et de faire réaliser ces dernières dans un garage <a href='https://blog.simpego.ch/fr/reseau-de-garages-partenaires/' target='blank'>partenaire</a> de simpego. En contrepartie, vous bénéficiez de primes casco plus avantageuses. En cas de sinistre, si vous ne respectez pas votre engagement, le contrat sera transformé en contrat avec convention de réparation «Libre choix du garage», et vous devrez vous acquitter de la différence de prime pour un an au maximum.<br><br><br> Convention de réparation Libre choix du garage <br><br>Vous pouvez choisir librement votre atelier de réparation.",
          options: {
            true: 'Libre choix du garage',
            false: 'Garage partenaire',
          },
        },
        glass: {
          label: 'Bris de glace Plus (bloc optique)',
          infoText: 'Dans le cadre de l’assurance casco partielle, les bris de glace ne couvrent que le pare-brise, les vitres latérales et la lunette arrière ainsi que le toit ouvrant en verre. Les matériaux faisant office de verre sont eux aussi assurés (bris de glace Basis).<br><br>Bris de glace Plus (bloc optique)<br>Les bris de glace affectant toutes les autres pièces automobiles en verre (bloc optique tel que phares, clignotants, etc.) sont eux aussi assurés. Les matériaux faisant office de verre sont eux aussi assurés. Les ampoules et les diodes (LED) cassées lors du bris de glace sont également assurées.',
        },
        personal_effects_coverage: {
          label: 'Somme d’assurance pour les objets personnels emportés',
          infoText: "L'assurance couvre les effets personnels emportés par les passagers qui sont volés avec le véhicule verrouillé ou dans le véhicule verrouillé ou endommagés en cas de dommages assurés sur le véhicule. Simpego paiera la réparation jusqu'à concurrence de la somme d´assurance convenue, en cas de perte totale, le montant pour l'achat d´un véhicule neuf.",
        },
        suspension: {
          label: 'Dépôt de plaque (suspension)',
          text: 'sans remboursement de prime',
          infoText: 'Si vous déposez temporairement les plaques, la prime ne sera pas remboursée au prorata.',
        },
        protective_clothing: {
          label: 'Vêtements de protection (passager inclus, valeur à neuf)',
          infoText: 'Dans le cadre d\´un événement de coque assuré, les vêtements de protection du conducteur, y compris du passager (copilote), sont assurés à leur valeur à neuf. Les vêtements de protection comprennent les casques, les lunettes de protection, les gants, les bottes, les protecteurs, les voitures familiales et les combinaisons de protection.',
          fieldName: 'Vêtements de protection',
        },
      },
      passenger_accident: {
        label: 'Assurance-accidents',
        labelHint: 'tous les occupants, prestations par personne, frais de guérison assuré',
        infoText: "Notre assurance accident vous protège, vous et tous les occupants, contre les conséquences financières d'un accident avec le véhicule assuré.<br><br>Ce qui suit s'applique à toutes les variantes : frais médicaux - département privé.<br><br>Standard : indemnités journalières CHF 25, invalidité CHF 60´000, décès CHF 30´000<br><br>Basic: indemnités journalières CHF 30, invalidité CHF 80´000, décès CHF 40´000<br><br>Plus : indemnités journalières CHF 40, invalidité CHF 100´000, décès CHF 50´000<br><br>Toutes les prestations sont applicables par personne. Les prestations sont versées immédiatement, c'est-à-dire avant le règlement de la dette.<br><br>En cas de blessure d'un animal de compagnie dans le véhicule, nous prenons en charge les soins jusqu'à CHF 2´500 par animal et jusqu'à un maximum de CHF 5´000 par événement.",
      },
      negligence: {
        label: 'Assurance pour faute grave',
        infoText: 'Nous vous offrons une couverture d\´assurance complète même si l\´accident a été causé par une négligence grave - par exemple si vous avez été distrait brièvement et avez grillé un feu rouge. Dans ce cas, nous renonçons à notre droit de recours ou de réduction. Toutefois, cela ne s\´applique pas si l\´aptitude à conduire était limitée par l\´abus d\´alcool, de drogues ou de médicaments.',
      },
      assistance24: {
        label: 'Assistance 24h/24',
        infoText: "Nos services vous apportent la sécurité nécessaire en cas de pannes et d'accidents : nous prenons en charge l'organisation et les coûts de l'assistance sur place en cas de pannes et d'accidents et assurons votre mobilité.<br><br>Avec Assistance Basic et Plus sont entre autres Les prestations d'assistance suivantes sont assurées :<br><br>Assistance en cas de panne, remorquage et récupération du véhicule jusqu'à l'atelier de réparation approprié le plus proche (Basic), récupération du véhicule jusqu'au garage de votre choix (Plus), frais de séjour, frais de déplacement, transport retour du véhicule, mobilité assurée (avec location/remplacement, transports publics, taxi) jusqu'à CHF 1 500 (Basic) ou CHF 4 000 (Plus), Service de notification.",
      },
      daily_termination: {
        label: 'Droit de résiliation journalier',
      },
      payment_frequency: {
        label: 'Fréquence de paiement',
        infoText: 'Vous pouvez payer votre prime semestriellement ou annuellement à l\´avance. Une surtaxe est perçue pour les paiements effectués au cours de l\´année.',
      },
      payment_type: {
        label: 'Mode de paiement',
        invoice: 'sur la facture',
        creditCard: 'Carte de crédit',
      },
      document_delivery: {
        label: 'Mode d’envoi des documents',
        infoText: 'Tous les documents vous seront envoyés par voie electronique.',
        email: 'électroniquement par courriel',
      },
      taxesTotal: {
        label: 'Taxes légales',
        infoText: 'Les taxes légales se composent comme suit : <br> - Droit de timbre 5% de la prime d\´assurance responsabilité et dommages <br> - Prélèvement SVG CHF 4.20 (selon les articles 74 et 76a SVG, sur la prime de responsabilité)<br> - Contribution prévention des accidents 0.75% de la prime de responsabilité',
      },
      priceTotal: {
        label: 'Prime annuelle total',
        infoText: 'Votre prime selon le mode de paiement choisi, y compris tous les frais et charges.',
      },
      errors: {
        vehicleLeasing: 'Les véhicules en leasing nécessitent une assurance collision.',
      },
    },
    customized: 'personnalisé',
    comprehensives: {
      notWanted: 'pas souhaité',
      liability: 'Responsabilité civile',
      partially_comprehensive: 'Casco partielle',
      fully_comprehensive: 'Casco complète',
    },
  },
  vehicleSelect: {
    basics: {
      initialRegistrationYear: '1ère mise en circulation',
      chooseCar: {
        text: 'Choisir un véhicule',
        infoText: 'Veuillez sélectionner votre véhicule le plus précisément possible. Les écarts mineurs dans le type de véhicule ne sont généralement pas un problème et n\´ont pas d\´influence sur la prime d\´assurance. L\´Office de la circulation routière nous communiquera les données exactes de votre véhicule au moment de l\´immatriculation de votre véhicule. En cas de divergence majeure, nous vous contacterons.',
      },
    },
    comfort: {
      brand: 'Marque de mon véhicule',
      model: 'Modèle',
      fuelType: 'Type de moteur',
      vehicleCategory: 'Catégorie',
      vehiclePower: 'La puissance s’élève',
      transmission: 'Boîte de vitesses',
    },
    vehicleNumber: {
      typeCertificateNumber: {
        label: 'Numéro de réception par type',
        placeholder: 'Paragraphe 24 du permis de circulation',
      },
    },
    selected: {
      headline: {
        text: 'Le véhicule choisi',
        infoText: 'Veuillez sélectionner votre véhicule le plus précisément possible. Les écarts mineurs dans le type de véhicule ne sont généralement pas un problème et n\´ont pas d\´influence sur la prime d\´assurance. L\´Office de la circulation routière nous communiquera les données exactes de votre véhicule au moment de l\´immatriculation de votre véhicule. En cas de divergence majeure, nous vous contacterons.',
      },
      btn1: 'Choisir un nouveau véhicule',
      btn2: 'Accepter le véhicule',
    },
  },
  vehicleData: {
    headline: 'Données du véhicule',
    ownedSince: {
      label: 'En possession depuis',
      infoText: 'Indiquez depuis combien de temps vous êtes en possession du véhicule.',
    },
    canton: {
      label: 'Canton d\´immatriculation',
      infoText: 'Précisez le canton dans lequel le véhicule doit être immatriculé.',
    },
    businessUsage: {
      label: 'Le véhicule sera-t-il utilisé à des fins professionnelles ?',
      infoPerson: "Utilisez-vous également le véhicule pour le compte de l'employeur ? p. ex. service extérieur",
      infoCompany: 'Est-ce que vous utiliserez le véhicule également à titre professionnel ? ',
    },
    transport: {
      label: 'Le véhicule est-il utilisé pour le transport commercial, commercial de passagers ou de marchandises ?',
      infoText: 'L\´usage commercial, doit être choisi si vos intérêts (commerciaux) sont destinés à générer des profits en transportant des marchandises ou des personnes.',
    },
    leasing: {
      label: 'Leasing',
      infoText: 'Veuillez indiquer si le véhicule est en leasing. Veuillez prendre en considération qu\´une assurance tous risques est habituellement exigée pour un véhicule en leasing.',
    },
    startOfInsurance: {
      label: 'Date de début de l’assurance',
      infoText: 'Sélectionnez ici la date de début de votre assurance personalisée. Votre assurance entre en vigueur à ce moment-là.',
    },
    errors: {
      vehicleLeasing: 'Les véhicules en leasing nécessitent une assurance collision. Nous avons adapté votre couverture en conséquence.',
    },
    vehicleRegistrationType: {
      label: 'Le véhicule est immatriculé en tant que',
      info: 'Veuillez indiquer si le véhicule sera immatriculé en tant que voiture de livraison ou comme voiture de tourisme.',
      car: 'Voiture de tourisme',
      van: 'Voiture de livraison',
      carOrVan: 'Voiture de tourisme / livraison',
      motorbike: 'Moto',
    },
    truckExtEquipment: {
      label: 'Avez-vous des superstructures supplémentaires pour ce véhicule?',
      info: 'Le terme "superstructure" désigne les superstructures de véhicule montées de manière fixe et permanente (par ex. caisse, structure de boîte, pont, benne basculante, etc.) qui sont exclusivement destinées à être utilisées avec le véhicule assuré et ne sont pas comprises dans le prix catalogue du véhicule. Les objets qui y sont transportés ne font pas partie de la carrosserie.',
      inputHint: 'Saisissez une valeur comprise entre CHF 0 - 999\´999',
      fieldName: 'Superstructures',
    },
    truckIntEquipment: {
      label: 'Le véhicule est-il équipé de dispositifs spéciaux?',
      info: 'Le terme "dispositifs" se réfère à l\´équipement permanent du véhicule (par ex. pour les camionnettes de service, les concierges, etc.) qui est exclusivement destiné à être utilisé avec le véhicule assuré et n\´est pas inclus dans le prix catalogue du véhicule. Les objets transportés dans le véhicule ne sont pas inclus dans l\´installation.',
      inputHint: 'Saisissez une valeur comprise entre CHF 0 - 999\´999',
      fieldName: 'Dispositifs',
    },
  },
  owner: {
    headline: 'Données du détenteur',
    nationality: {
      label: 'Nationalité',
      infoText: 'Veuillez vous assurer que votre nationalité que vous avez indiqué est la même qu\´au service des automobiles',
    },
    residencePermit: {
      label: 'Permis de séjour',
      infoText: 'Indiquez le type de votre permis de séjour.',
      B1: 'B',
      C: 'C',
      L: 'autres',
    },
    driverLicenceSinceYear: {
      label: 'Permis de conduire depuis (année)',
      infoText: 'Veuillez indiquer depuis quand vous êtes autorisé à conduire une voiture particulière dans la circulation. Un âge minimum de 17 ans est requis.',
    },
    isKeeperMainDriver: {
      label: 'Est-ce que le détenteur sera le conducteur principal ?',
      infoText: 'Veuillez indiquer si quelqu\´un d\´autre que vous en tant que propriétaire du véhicule est l\´utilisateur le plus fréquent du véhicule.',
    },
    youngDriver: {
      label: 'Des personnes de moins de 25 ans utilisent-elles le véhicule ?',
      infoText: 'Veuillez indiquer si des personnes âgées de moins de 25 ans utilisent le véhicule.',
      youngDriverOptions: {
        male: 'oui, un homme',
        female: 'oui, une femme',
        both: 'oui, les deux',
      },
    },
    driverLicenceWithdrawal: {
      label: 'Est-ce qu’on vous a retiré le permis de conduire au cours des 5 dernières années pour plus de 3 mois, votre police d’assurance a-t-elle été résiliée ou refusée ?',
      labelMainDriver: 'Votre permis de conduire ou celui du conducteur le plus fréquent a-t-il été retiré pour plus de 3 mois au cours des 5 dernières années, ou une police a-t-elle été annulée ou refusée ?',
      infoPerson: 'Veuillez indiquer si votre permis de conduire a été retiré au cours des 5 dernières années, si une compagnie d\´assurance a rejeté votre demande, si un contrat d\´assurance a été annulé ou si le maintien de votre contrat d\´assurance a été soumis à des conditions difficiles.',
      infoCompany: 'Veuillez indiquer si, au cours des 5 dernières années, une compagnie d\´assurance a rejeté votre demande, annulé votre contrat d\´assurance ou soumis le maintien de votre police à des conditions plus difficiles.',
      infoMainDriver: "Veuillez indiquer si votre permis de conduire ou celui du conducteur le plus fréquent a été retiré au cours des 5 dernières années, si une compagnie d'assurance a refusé votre proposition, si un contrat d'assurance a été annulé ou si la continuation du contrat a été soumise à des conditions difficiles.",
    },
    policyCancelledOrRejected: {
      label: 'Vous a-t-on résilié ou refusé une police d’assurance au cours des cinq dernières années ?',
    },
    tooManyAccidents: {
      label: 'Avez-vous eu 3 sinistres ou plus au cours des 3 dernières années?',
      labelMainDriver: 'Est-ce que vous ou le conducteur le plus fréquent avez eu 3 sinistres ou plus au cours des 3 dernières années ?',
      infoText: 'Veuillez déclarer tous les sinistres au cours des 3 dernières années pour lesquelles votre assurance a versé une prestation. Par exemple, les dommages de responsabilité, les dommages de collision, les dommages de stationnement, les dommages de matres, les dommages bris de glace, etc.',
      infoMainDriver: "Déclarez toutes les sinistres des 3 dernières années pour lesquels votre assurance ou l'assurance du conducteur le plus fréquent a versé une prestation. Par exemple, les dommages de responsabilité, les dommages de collision, les dommages de stationnement, les dommages causés à la martre, les dommages causés à la vitre, etc.",
    },
  },
  personalData: {
    headline: {
      agent: 'Données de l\´intérmédiaire',
      person: 'Données personnelles',
      personForAgent: 'Données personnelles du client',
    },
    agentEmail: {
      label: 'Courriel éléctronique de l\´intérmédiaire',
    },
    customerDocuments: {
      label: 'Contrôle des documents clients',
      infoText: 'Choisissez si les documents doivent vous être envoyés seulement à vous ou directement au client ou au client et vous en copie. <br> <br> Les documents concernés sont: <br> - Documents contractuels incl. factures <br> - Documents de renouvellement incl. factures',
      toAgent: 'seulement à l\´intérmédiaire',
      toCustomer: 'seulement au client',
      toCustomerAndAgent: 'au client en copie l\´intérmédiaire',
    },
    invoices: {
      label: 'Contrôle des factures de suivi en cours d\'année',
      infoText: "Choisissez si les factures doivent vous être envoyés seulement à vous ou directement au client ou au client et vous en copie. Les factures concernés sont : les factures de suivi en cours d\'année. La commande d'envoi des factures de suivi en cours d'année permet également de gérer l'envoi des e-mails relatifs aux cartes de crédit (tels que l'enregistrement, l'impossibilité d'effectuer un prélèvement ou l'information sur une carte de crédit expirée ou invalide), c'est pourquoi le type de paiement par carte de crédit est sélectionné « uniquement au client » et ne peut pas être modifié.",
    },
    reminders: {
      label: 'Contrôle des documents de recouvrement de créances',
      infoText: 'Choisissez si les documents doivent vous être envoyés seulement à vous ou directement au client ou au client et vous en copie <br> Les documents concernés sont: <br> - Friendly Reminder <br> - Relance de paiement <br> - Rappels (le rappel est toujours envoyé en plus par courrier directement au client)',
    },
    agentMailsDelivery: {
      label: 'Contrôler les e-mails',
      infoText: 'Les e-mails envoyés à partir du canal de vente en ligne sont envoyés à l\´adresse e-mail de l\´agent, si sélection intermédiaire ou client cc intermédiaire. <br> Si sélection "client", les mails sont envoyés uniquement au client.<br><br>Mails concernés :<br> - Courriels d\´offres. <br> - Notification lors de la conclusion d\´un contrat. <br> - Confirmation d\´envoi de l\´attestation d\´assurance <br> - tous les courriels pour le suivi',
      dispatchDocumentOptions: {
        option1: 'au client en copie l\´intérmédiaire',
        option2: 'seulement à l\´intérmédiaire',
        option3: 'seulement au client',
      },
      toAgent: 'seulement à l\´intérmédiaire',
      toCustomer: 'seulement au client',
      toCustomerAndAgent: 'au client en copie l\´intérmédiaire',
    },
    btn: 'Vérifier les entrées',
    errors: {
      zipCode: 'Veuillez entrer un code postal valide.',
    },
    industry: {
      infoText: 'Veuillez indiquer votre secteur d\´activité selon l\´inscription au registre du commerce',
    },
    emailInfoText: 'Nous avons besoin de cette adresse pour ouvrir un dossier client. Tous les courriels en rapport avec cette offre (p. ex. les courriels d\´offre ou de suivi) ou la confirmation de réception du contrat d\´assurance (courriel de contrat) seront envoyés à l\´adresse courriel de l\´intermédiaire choisi ci-dessus, et non au client. Veuillez utiliser le champ "Contrôle des documents du client" pour contrôler à qui les documents sont envoyés après l\´établissement de la police.',
    warningAgentEmail: 'Veuillez vérifier votre inscription. L\'adresse électronique du client ne peut pas coïncider avec l\'une des adresses électroniques de l\'intermédiaire.',
    warningPhoneTracking: 'Veuillez noter que chaque numéro de mobile ne peut être utilisé que pour un seul contrat FlexDrive/BonusDrive actif. Un numéro de mobile distinct est requis pour chaque contrat supplémentaire.',
  },
  priceBox: {
    tariffOptions: {
      liabilityDeductible: 'Responsabilité civile <em>Franchise (CHF {deductible})</em>',
      partiallyComprehensiveDeductible: 'Casco partielle <em>Franchise (CHF {deductible})</em>',
      fullyComprehensiveDeductible: 'Assurance collision <em>Auto franchise (CHF {deductible})</em>',
      parkDamageDeductible: 'Dommages de parc <em>Franchise (CHF {deductible})</em>.',
      freeGarage: 'Convention de réparation: <em>{free_garage}</em>',
      protectiveClothing: 'Vêtements de protection <em>(CHF {value})</em>',
      glass: 'Bris de glace Plus (bloc optique)',
      personalEffectsCoverage: 'Objets transportés (CHF {coverage})',
      parkDamage: 'Couverture contre les dommages de parc <span class="{bundleClass}">{bundle}</span>.',
      passengerAccident: 'Assurance accidents <span class="{bundleClass}">{bundle}</span>',
      grossNegligence: 'Assurance faute grave',
      assistance24: '24 h Assistance  <span class="{bundleClass}">{bundle}</span>',
      dailyTermination: 'Droit de résiliation journalier',
    },
    pricePerYear: '{price} / année',
    pricePerKm: '{price} /km',
    maxPerYear: 'max. {price} CHF / année',
    exactKm: ' au kilomètre près',
  },
  checkout: {
    headline: {
      h3: 'Aperçu de votre offre',
      text: 'Encore un clic et vous avez une nouvelle assurance véhicule. Veuillez s’il vous plaît contrôler encore une fois les éléments indiqués jusqu’à présent.',
    },
    summary: {
      basics: {
        headline: 'Données générales concernant l’assurance',
        pricePerYear: 'année',
        startOfInsurance: 'Assuré dès le',
        endOfInsurance: 'Fin de l\'assurance',
        priceWithKmPremium: '{fix}/an + {perKm}/km, max. {max}/an',
        onlyKmPremium: '{perKm}/km, max. {max}/Jahr',
      },
      car: {
        headline: 'Données du véhicule',
        registrationType: 'Motif d’immatriculation',
        truckEquipmentLabel: 'Superstructures et installations supplémentaires',
      },
      payment: {
        headline: 'Informations concernant le paiement ',
        billEmail: 'Facture par e-mail',
        documentsEmail: 'électroniquement par courriel',
        creditCard: 'carte de crédit',
        monthly: 'Mensuellement',
        yearly: 'Anuelle',
        half_yearly: 'Semestrielle',
        quarterly: 'Trimestriel',
        billingModel: ' Modèle de facturation ',
      },
      checkoutlegal_checkbox: {
        agbUrl: 'https://doc.simpego.ch/fr/conditions-generales/cg/',
        privacyUrl: 'https://www.simpego.ch/fr/protection-des-donnees',
        agent: {
          part1: 'Je confirme que le client a lu et a compris',
          part2: 'conditions générales d\´assurances (CGA)',
          part3: 'et les',
          part4: 'conditions générales (CG)',
          part5: 'ainsi que la',
          part6: 'protection des données',
          part7: 'Je les accepte et confirme également que je suis autorisé à conclure le présent contrat ou que j\´ai un mandat signé. En outre, je confirme que j\´ai rempli mon obligation d\´informer le client conformément à l\´art. 45 LSA.',
        },
        person: {
          part1: 'Oui, j\´aimerais souscrire un contrat d\´assurance en ligne et confirme que j\´ai lu et compris les conditions suivantes : ',
          part2: 'conditions générales d\´assurances (CGA)',
          part3: 'et les',
          part4: 'conditions générales (CG)',
          part5: 'ainsi que la',
          part6: 'protection des données',
          part7: 'J\´en ai pris note et j\´accepte.',
        },
      },
      consultationProtocol: {
        input: 'Téléchargement du protocole de conseil ou du mandat client',
        tooltip: "Vous avez ici la possibilité de télécharger votre protocole de conseil ou votre mandat client. Ce document est ensuite transmis à simpego en même temps que la demande d'offre et classé avec l'offre correspondante. Si vous calculez plusieurs variantes d'offres, le document téléchargé s'affiche pour chaque offre et vous avez la possibilité de le supprimer et d'en télécharger un nouveau.",
        clear: 'Vider le champ de saisie',
        errors: {
          size: 'La taille du document ne doit pas dépasser 5 Mo.',
          type: 'Le téléchargement du document s\'est malheureusement mal\n'
            + 'passé. Les formats autorisés pour le document sont : pdf, jpeg, png.',
        },
      },
      btn: {
        signContact: 'Conclure contrat',
        requestProposal: 'Demander une offre',
      },
      tariffOptions: {
        liabilityDeductible: 'Responsabilité civile franchise CHF (CHF {deductible})',
        partiallyComprehensiveDeductible: 'Franchise couverture partielle (CHF {deductible})',
        fullyComprehensiveDeductible: 'Franchise collision (CHF {deductible})',
        parkDamageDeductible: 'Franchise sur les dommages de parc (CHF {deductible})',
        protectiveClothing: 'Vêtements de protection (CHF {value})',
        glass: 'Bris de glace Plus (bloc optique)',
        freeGarage: 'Convention de réparation: {free_garage}',
        personalEffectsCoverage: 'Objets transportés (CHF {coverage})',
        parkDamage: 'Couverture contre les dommages de parc {bundle}',
        passengerAccident: 'Assurance accidents {bundle}.',
        grossNegligence: 'Assurance faute grave',
        assistance24: '24 h Assistance {bundle}',
        dailyTermination: 'Droit de résiliation journalier',
        suspension: 'Dépôt de plaque (suspension) sans remboursement de prime',
      },
    },
    errors: {
      applyContract: 'Une erreur s\´est produite.',
      requestProposal: 'Une erreur s\´est produite. Veuillez réessayer.',
    },
    specialConditions: {
      payPerKM: {
        title: 'Conditions particulières : Car Paiement par Km',
        conditions: [
          {
            text: 'En cas de contradiction entre les conditions générales d\´assurance (CGA) applicables au contrat d\´assurance et les présentes conditions conditions particulières (CC), les CGA s\´appliquent',
          },
          {
            headline: 'Qu\´est-ce que Car FlexDrive :',
            text: 'Avec FlexDrive, toute la prime ou une partie de la prime de votre contrat d\´assurance est basée sur le nombre de kilomètres parcourus par le véhicule assuré. La prime indiquée dans le contrat d\´assurance est payable au kilomètre. Toute prime fixe convenue est due quel que soit le nombre de kilomètres parcourus.',
          },
          {
            headline: 'Montant maximal par année :',
            text: 'La prime maximale payable par année (montant maximal) est précisée dans votre police d\´assurance. Si le montant maximal est réglé, il n\´y a pas de prime supplémentaire pour le reste de l\´année d\´assurance, à condition que le contrat reste inchangé.',
          },
          {
            headline: 'Paiement des primes et conséquences du non-paiement',
            text: 'Une fois par mois, la carte de crédit que vous avez indiquée dans l\´application autoSense sera débitée. La prime par kilomètre pour la distance parcourue au cours du mois précédent et un douzième de toute prime fixe seront débités. Le montant débité comprend déjà les charges et frais légaux. Simpego vous enverra une facture électronique pour chaque débit. Elle contient le nombre de kilomètres parcourus, la prime due à ce titre et toute prime fixe. Si le montant dû ne peut être débité de la carte de crédit que vous avez déposée dans l\´application autoSense dans les 30 jours, Simpego a le droit d\´exiger immédiatement le montant maximum spécifié dans le contrat. Nous vous enverrons une facture pour la réclamation du montant maximum. Les primes déjà payées pour cette année d\´assurance seront déduites du montant maximum. Pour le reste de la durée du contrat, il n\´y a pas d\´autres frais de prime, à condition que le contrat demeure inchangé.',
          },
          {
            headline: 'Recours en rapport avec le sinistre',
            text: 'Pour les franchises et les recours, nous vous enverrons une facture en lien avec les sinistres. Ces montants ne seront pas débités sur votre carte de crédit.',
          },
          {
            headline: 'Conditions d\´utilisation de Car PaiementparKM',
            text: 'Pour l\´utilisation de FlexDrive, vous vous engagez à ne pas retirer l\´adaptateur autoSense du véhicule pendant la durée du contrat, ou seulement dans des cas justifiés.',
          },
          {
            headline: 'déconnecté',
            text: 'Si l\´adaptateur autoSense est retiré du véhicule, une déconnexion se produit. Ceci est signalé par autoSense à Simpego, de même que la connexion dès que l\´adaptateur est reconnecté. Si le véhicule a été déplacé de plus de 100 mètres lors d\´une déconnexion, c\´est-à-dire sans adaptateur connecté (différence de kilométrage du véhicule entre déconnexion et connexion), Simpego peut vous demander une explication écrite. Simpego se réserve également le droit de renoncer à la facturation au kilomètre après un débranchement. Dans ce cas, le montant maximum stipulé dans le contrat devient immédiatement exigible. Les primes déjà payées pour cette année d\´assurance seront déduites du montant maximum. Aucune autre prime n\´est facturée pour le reste de la durée du contrat, à condition que le contrat demeure inchangé. Nous vous enverrons une facture pour la réclamation du montant maximum. Ces montants ne seront pas portés à votre carte de crédit.',
          },
          {
            headline: 'Dépôt des plaques (suspension)',
            text: 'Les contrats d\´assurance FlexDrive qui comprennent une prime fixe ne changent pas si les plaques d\´immatriculation sont déposées au Bureau de la circulation routière et que le véhicule assuré demeure toujours en votre possession. La prime forfaitaire est également due si les plaques ont été déposées (couverture du risque d\´immobilisation). Les contrats d\´assurance FlexDrive qui ne comportent pas de prime fixe seront résiliés à compter de la date de dépôt des plaques d\´immatriculation.',
          },
          {
            headline: 'Résiliation et décompte',
            text: 'Si le contrat est résilié par vous ou par Simpego, il sera résilié à la date notifiée par l\´Office de la circulation routière. Votre carte de crédit enregistrée dans l\´application autoSense sera débitée seulement pour les kilomètres parcourus jusqu\´à la résiliation du contrat et proportionnellement de toute prime fixe. Le montant maximum est toujours dû après la résiliation dans les deux cas suivants : 1. vous résiliez le contrat en raison d\´un dommage partielle au cours de la première année d\´assurance et Simpego a payé la prestation d\´assurance pour les réparations des dommages partielles ; 2. le contrat est résilié en raison d\´un dommage totale (et donc la perte du risque assuré) et Simpego a payé l\´indemnité pour le dommage total. Les primes déjà payées pour cette année d\´assurance seront déduites du montant maximum. Nous vous enverrons une facture pour la réclamation du montant maximum après l\´ annulation. Ces montants ne seront pas portés à votre carte de crédit.',
          },
          {
            headline: 'Échange de données autoSense - Simpego :',
            text: 'L\´échange de données suivant a lieu entre autoSense AG et Simpego Versicherungen AG dès l\´activation du contrat :',
          },
          {
            text: 'Simpego annonce autoSense : statut du contrat, couverture d\´assurance, statut de la couverture d\´assurance, détails du véhicule assuré, prime à payer pour le mois précédent.',
          },
          {
            text: 'autoSense annonce à Simpego : état de l\´adaptateur (Déconnexion / Connexion), kilomètres parcourus dans la zone locale d\´application selon AVB, code de transaction du paiement.',
          },
          {
            text: 'Aucune information n\´est échangée entre Simpego et autoSense concernant votre comportement de conduite, votre emplacement ou l\´emplacement du véhicule, ou des informations relatives aux réclamations.',
          },
        ],
        privacy: {
          part1: 'Vous trouverez plus d\´informations sur la protection des données chez Simpego dans la rubrique "Protection des données" de notre site Internet. ',
          part2: 'Information sur le produit',
          part3: '.',
        },
      },
      kasko2go: {
        title: 'Conditions particulières : Kasko2go powered by Simpego',
        conditions: [
          {
            text: 'En cas de contradiction entre les conditions générales d\´assurance (CGA) applicables au contrat d\´assurance et les présentes conditions conditions particulières (CC), les CGA s\´appliquent',
          },
          {
            headline: 'Qu\´est-ce que c\´est kasko2go powered by Simpego ',
            text: 'Avec kasko2go motorisé par Simpego, une partie ou la totalité de la prime de votre contrat d\´assurance est basée sur le nombre de kilomètres parcourus par le véhicule assuré et le score calculé par kasko2go pour votre comportement au volant. Toute prime fixe convenue est due quels que soient le kilométrage parcouru et le score kasko2go.',
          },
          {
            headline: 'Montant maximal par année',
            text: 'La prime maximale payable par année (montant maximal) est précisée dans votre police d\´assurance. Si le montant maximal est réglé, il n\´y a pas de prime supplémentaire pour le reste de l\´année d\´assurance, à condition que le contrat reste inchangé.',
          },
          {
            headline: 'Paiement des primes et conséquences du non-paiement',
            text: 'Une fois par mois, la carte de crédit que vous avez indiquée dans l\´application kasko2go sera débitée. La prime par kilomètre est débitée de la distance parcourue au cours du mois précédent et d\´un douzième de toute prime fixe pour le mois suivant. Le montant débité comprend déjà les impôts et taxes statutaires. Si le montant dû ne peut être débité dans les 10 jours de la carte de crédit que vous avez déposée dans l\´application kasko2go, Simpego a le droit de demander immédiatement le montant maximum spécifié dans le contrat. Vous recevrez une facture à cet effet. Les primes déjà payées pour cette année d\´assurance seront déduites du montant maximum. Si le contrat demeure inchangé, il n\´y a pas d\´autres frais de prime, de kilométrage ou de considération de la cote kasko2go pour le reste de la durée du contrat.',
          },
          {
            headline: 'Recours en rapport avec le sinistre',
            text: 'Pour les franchises et les recours, nous vous enverrons une facture en lien avec les sinistres. Ces montants ne seront pas débités sur votre carte de crédit.',
          },
          {
            headline: 'Conditions d\´utilisation de Kasko2go powered by Simpego et les conséquences de la non-conformité',
            text: 'Pour l\´utilisation de kasko2go powered by Simpego, vous vous engagez à ce que chaque distance parcourue par le véhicule assuré soit mesurée par le conducteur respectif avec l\´application kasko2go. Pour cela, l\´appareil doit être allumé et l\´application kasko2go activée. Vous vous engagez également à déclarer le kilométrage du véhicule assuré dans l\´application kasko2go une fois par mois. Simpego se réserve le droit de vous demander une photo du kilométrage actuel à tout moment. Si vous ne fournissez pas une preuve comme une photo malgré des demandes répétées, Simpego se réserve le droit d\´exiger immédiatement le montant maximum. Les primes déjà payées pour cette année d\´assurance seront déduites du montant maximum. Si le contrat reste inchangé, aucune autre prime ne sera facturée pour le reste de la période du contrat, ni pour le calcul du kilométrage ou la considération du score kasko2Go.',
          },
          {
            headline: 'Différences sur l\´état du kilométrage',
            text: 'Si des différences sont constatées entre le kilométrage que vous avez indiqué via l\´application kasko2go et le kilométrage mesuré par l\´application kasko2go, Simpego a le droit de demander immédiatement le montant maximum. Les primes déjà payées pour cette année d\´assurance seront déduites du montant maximum. Si le contrat demeure inchangé, aucune autre prime ne sera facturée pour le reste de la période du contrat, aucune facturation de kilométrage ou considération du pointage kasko2go.',
          },
          {
            headline: 'Dépôt des plaques (suspension)',
            text: 'kasko2go powered by Simpego avec ces contrats d\´assurance, qui comprennent une prime fixe. -Les primes ne changent pas si les plaques d\´immatriculation sont déposées au Bureau de la circulation routière et que le véhicule assuré demeure toujours en votre possession. La prime fixe est également due si les plaques d\´immatriculation ont été déposées (couverture du risque d\´immobilisation). kasko2go powered par les contrats d\´assurances de Simpego qui ne comportent pas de prime fixe seront annulées à compter de la date du dépôt de l\´enseigne.',
          },
          {
            headline: 'Résiliation et décompte',
            text: 'Si le contrat est résilié par vous ou par Simpego, il sera résilié à la date notifiée par l\´Office de la circulation routière. Votre carte de crédit enregistrée dans l\´application autoSense sera débitée seulement pour les kilomètres parcourus jusqu\´à la résiliation du contrat et proportionnellement de toute prime fixe. Le montant maximum est toujours dû après la résiliation dans les deux cas suivants : 1. vous résiliez le contrat en raison d\´un dommage partielle au cours de la première année d\´assurance et Simpego a payé la prestation d\´assurance pour les réparations des dommages partielles ; 2. le contrat est résilié en raison d\´un dommage totale (et donc la perte du risque assuré) et Simpego a payé l\´indemnité pour le dommage total. Les primes déjà payées pour cette année d\´assurance seront déduites du montant maximum. Nous vous enverrons une facture pour la réclamation du montant maximum après l\´ annulation. Ces montants ne seront pas portés à votre carte de crédit.',
          },
          {
            headline: 'Echange de données kasko2go - Simpego',
            text: 'L\´échange de données suivant a lieu entre kasko2go AG et Simpego Versicherungen AG dès l\´activation du contrat :',
          },
          {
            text: 'Simpego communique à kasko2go l\´état du contrat, la couverture d\´assurance, les informations sur les primes et les données relatives aux sinistres du véhicule assuré (date de sinistre, type de sinistre, origine, montant).',
          },
          {
            text: 'kasko2go communique à Simpego les kilomètres parcourus dans la zone d\´application locale conformément aux CGA, le code de transaction du paiement, le score du comportement de conduite par mois, toutes les données collectées aux fins de la demande et de l\´établissement du contrat au nom du titulaire de la police, le conducteur, le véhicule assuré et les couvertures assurées.',
          },
          {
            text: 'Simpego et kasko2go n\´échangent aucune information sur votre comportement de conduite, votre emplacement ou l\´emplacement du véhicule ou toute autre donnée non mentionnée ici à part le score final.',
          },
        ],
        privacy: {
          part1: 'Vous trouverez plus d\´informations sur la protection des données chez Simpego dans la rubrique "Protection des données" de notre site Internet. ',
          part2: 'Information sur le produit',
          part3: '.',
        },
      },
    },
  },
  offer: {
    headline: 'Votre offre est en route !',
    text: "Nous vous remercions de l'intérêt que vous portez à l'assurance véhicule chez Simpego. Nous vous avons envoyé l'offre que vous avez demandé à l'adresse e-mail que vous nous avez fournie. Veuillez consulter votre boîte e-mail.",
    mailText: 'Si vous avez des questions, n\´hésitez pas à nous contacter',
  },
  confirmation: {
    headline: 'Merci d\´avoir souscrit cette police. Bienvenue dans la famille Simpego ! ',
    headlineText: 'Pour l\´activation de votre nouvelle assurance véhicule, nous avons encore besoin de quelques détails : ',
    form: {
      licencePlateAvailable: 'Avez-vous déjà un numéro de plaque pour ce véhicule ? ',
      licencePlate: 'Quelle est votre numéro de plaque ? ',
      licencePlateActive: 'La plaque d’immatriculation est-elle actuellement utilisée ou en circulation ? ',
      vehicleRegisteredToOwner: 'Le véhicule{vehicleModel} est-il en ce moment déjà immatriculé sur le nom du {policyholder} ?',
      licencePlateRegisteredToOwner: 'Ce numéro de plaque est-il actuellement utilisé sur {policyholder} ?',
      defaultPolicyholder: 'le preneur d\´assurance',
      registeredToDextra: 'Étiez-vous auparavant assuré auprès de Simpego avec ce véhicule ?',
      serialNumber: {
        text: 'Veuillez indiquer le numéro de matricule du véhicule à assurer. Si vous ne connaissez pas encore le numéro de matricule ou si vous ne l\´avez pas sous la main, veuillez cliquer sur le bouton "Indiquer les informations plus tard". Vous avez déjà reçu un e-mail de confirmation de notre part confirmant la conclusion du contrat, qui contient un lien vers cette page. Veuillez noter que nous avons absolument besoin du numéro de matricule pour établir une attestation d\´assurance.',
        label: 'Numéro de matricule',
      },
      btn: {
        submit: 'Commander une attestation d\´assurance',
        infoLater: 'Indiquer les informations plus tard',
      },
      infoLaterPopup: 'Si vous souhaitez saisir les informations ultérieurement, ce n\´est pas un problème. Vous avez déjà reçu un e-mail de notre part confirmant la conclusion de contrat. <br>Dans cet e-mail, vous trouverez un lien vers cette page. En cliquant sur le lien, vous pouvez revenir ici à tout moment et fournir les informations manquantes. <br>Si vous avez des questions, n\´hésitez pas à nous contacter <a href="mailto:service@simpego.ch">service@simpego.ch</a>',
      inputTypeQuestions: 'Déterminer le motif d\´immatriculation',
      inputTypeDirect: 'Sélectionnez le motif d\´immatriculation',
    },
    ivReason: {
      label: 'Motif d\´immatriculation',
      new: '57 - Nouvelle immatriculation',
      reactivation: '52 - WIK A',
      vehicleChange: '58 - Changement de véhicule',
      ownerChange: '59 - Changement de détenteur',
      insurerChange: '54 - Changement d\´assurance',
      none: 'aucun VNA requis',
    },
  },
  infoLater: {
    headline: 'Indiquer les informations plus tard',
    text: 'Si vous souhaitez saisir les informations ultérieurement, ce n\´est pas un problème. Vous avez déjà reçu un e-mail de notre part confirmant votre conclusion de contrat. <br>Dans cet e-mail, vous trouverez un lien vers cette page. En cliquant sur le lien, vous pouvez revenir ici à tout moment et fournir les informations manquantes.',
    emailText: 'Si vous avez des questions, n\´hésitez pas à nous contacter.',
    btn: 'Indiquer les informations',
  },
  offerExpired: {
    headline: 'Malheureusement, votre offre n\´est plus valable.',
    text1: 'Si vous avez des questions, n\´hésitez pas à contacter notre équipe Customer Solution Center, qui vous offre un service amical et orienté solutions.',
    text2: 'Lun au jeu : 07:30 - 18:00 heures et VE : 07:30 - 17:00 heures sous le numéro : +41 58 521 11 11 11',
    mailText: 'Ou par courriel éléctronique',
    text3: 'Vous pouvez également calculer une nouvelle offre :',
    newInsuranceRequest: 'Recalculer la prime maintenant',
  },
  rejected: {
    headline: 'mentions, informations, communication',
    text1: 'Votre offre est actuellement en cours de traitement auprès de Simpego raison pour laquelle le lien dans l\´email que vous avez reçu n\´est plus actif. Si vous avez des questions, n\´hésitez pas à contacter notre équipe Customer Solution Center, qui vous offre un service amical et orienté solutions.',
  },
  finish: {
    headline: 'Bienvenue auprè de la meilleure* assurance de Suisse ',
    text1: 'Merci beaucoup pour vos informations. Quelle est la suite ?',
    list1: 'Etant donné que nous connaissons maintenant votre numéro de matricule, nous enverrons immédiatement l\´attestation d\´assurance par voie électronique au service des automobiles. Vous pourrez alors immatriculer votre véhicule',
    list2: 'Une fois votre véhicule immatriculé, nous vous enverrons vos documents d\´assurance et la facture de prime.',
    hint: '*Maintenant, nous vous avons convaincu.',
    homeButton: 'Aller à la page d\´accueil',
  },
  declined: {
    headline: 'mentions, informations, communication',
    text1: 'Malheureusement, nous ne pouvons pas vous offrir une assurance pour votre véhicule pour le moment.',
    text2: 'Nous vous demandons votre compréhension.',
    back: 'retour',
    reason: 'Raison:',
    defaultReason: "Pas d'offre possible",
  },
  renewalOfferings: {
    pageTitle: 'Vos offres de renouvellement',
    currentContract: 'Contrat actuel',
    proposal: 'Proposition',
    policyNumber: 'Contrat n° {number}',
    perYear: '/ Année',
    yourData: 'Vos données',
    name: 'Nom',
    birthdate: 'Date de naissance',
    email: 'E-mail',
    acceptProposal: 'Accepter la proposition',
    ourRecommendation: 'Notre recommandation',
    ourRecommendationLine1: 'Notre',
    ourRecommendationLine2: 'recommandation',
    confirmAcceptText: 'Souhaitez-vous accepter la proposition "{proposalTitle}" avec une prime de CHF {premium} par année?',
    offerExpired: 'Offre expirée',
    offerExpiredMessage: "L'offre de renouvellement a malheureusement expiré.",
    contactSupport: 'Veuillez contacter notre service clientèle pour toute question.',
    noOffersAvailable: 'Aucune offre disponible',
    alreadySelectedOrExpired: 'Une offre a déjà été sélectionnée ou les offres ont expiré.',
    offerExpiredOrInvalid: "L'offre a expiré ou est invalide.",
    deductiblePersonalEffects: 'Franchise objets transportés',
    replacementValueSupplement: 'Supplément valeur à neuf',
    standStillRisk: "Risque d'immobilisation",
    insuredPersons: 'Personnes assurées',
    insuredPersonsList: {
      3: 'tous les occupants',
    },
    deathBenefit: 'Capital décès',
    disabilityCapital: 'Capital invalidité',
    dailyCompensation: 'Indemnité journalière dès le 1er jour',
    hospitalDailyCompensation: 'Indemnité journalière hospitalière',
    healingCosts: 'Frais de guérison couverts',
    medicalExpenses: 'Frais de guérison couverts',
    documentDispatch: 'Envoi de documents',
    paymentFrequency: 'Fréquence de paiement',
    electronic: 'électronique',
    paper: 'papier',
    yearly: 'annuel',
    halfYearly: 'semestriel',
    quarterly: 'trimestriel',
    monthly: 'mensuel',
    yes: 'Oui',
    no: 'Non',
    licensePlateDeposit: 'Dépôt de plaques avec remboursement de prime',
    error: 'Erreur',
    errorOccurred: 'Une erreur s\'est produite. Veuillez réessayer.',
    technicalError: 'Une erreur technique s\'est produite. Veuillez réessayer plus tard.',
    ok: 'OK',
    cancel: 'Annuler',
    validUntil: 'Offre valable jusqu\'au {date}',
    glassPlusWithSmallGlass: 'Bris de glace Plus (bloc optique)',
    glassBasis: 'Bris de glace Base',
    flexDrivePricing: 'Détails du tarif FlexDrive',
    capPremium: 'Prime plafond',
    fixPremiumKm: 'Prime fixe / km',
    totalPremiumKm: 'Prime totale / km',
    legalFees: 'Taxes légales',
    maxPerYear: 'max. {price}',
    success: {
      headline: 'Proposition acceptée avec succès!',
      message: 'Nous avons reçu vos données, merci beaucoup!',
      nextStepsHeadline: 'Que se passe-t-il ensuite?',
      nextStepsText: 'Vous recevrez bientôt un e-mail de confirmation avec tous les détails\nVotre contrat actuel sera automatiquement résilié\nLe nouveau contrat entrera en vigueur le {date}\nNotre service clientèle est à votre disposition pour toute question',
      backToHome: "Retour à la page d'accueil",
    },
  },
  errorPage: {
    headline: 'mentions, informations, communication',
    customerText: 'Une erreur s\´est produite. Veuillez contacter le service à la clientèle.',
    agent: {
      text1: 'Malheureusement, une erreur s\´est produite.',
      text2: 'Pour les raisons suivantes : ',
      text3: '- Il y a un problème technique avec cette page',
      text4: '- Votre profil d\´intermédiaire attend d\´être activé par Simpego',
      text5: '- Votre profil d\'agent a été verrouillé.',
      mail: 'Veuillez signaler cette erreur à notre Customer Solution Center par courrier.',
      tel: 'ou par téléphone au +41 58 521 11 11 11.',
      text6: 'Nous sommes joignables du Lundi au Jeu : 07:30 - 18:00 heures et Fr : 07:30 - 17:00 heures.',
    },
  },
  mediator: {
    mediatorData: 'Données de l\´intérmédiaire',
    mediatorName: 'Nom de l\´intermédiaire/société',
    mediatorID: 'Numéro d\´identification de l\´intermédiaire',
    refreshWarning: 'Voulez-vous commencer un nouveau calcul ? (Les données déjà saisies seront perdues !)',
    endSessionWarning: 'Voulez-vous supprimer votre authentification d\´intermédiaire ? (Les données déjà saisies seront perdues)',
  },
  servicePage: {
    headline: 'Malheureusement, une erreur s\´est produite.',
    content: 'Cette page est actuellement en cours de maintenance.<br> C\´est pourquoi nous ne pouvons pas vous proposer un calcul de prix pour le moment.<br> Veuillez réessayer à une date ultérieure - merci beaucoup ! <br><br> Votre équipe Simpego',
  },
  validation: {
    messages: {
      required: 'Veuillez répondre à cette question',
      validate_integer: 'Veuillez entrer un nombre correct.',
    },
    custom: {
      ownedSince: {
        required: 'Veuillez sélectionner l\´année d\´achat du véhicule',
      },
      businessUsage: {
        required: 'Veuillez indiquer si le véhicule est destinée à un usage privé ou professionnel',
      },
      canton: {
        required: 'Veuillez sélectionner le canton dans lequel la voiture doit être assurée.',
      },
      leasing: {
        required: 'Veuillez indiquer si le véhicule a été pris en leasing',
      },
      nationality: {
        required: 'Veuillez indiquer votre nationalité',
      },
      otherNationality: {
        required: 'Veuillez indiquer votre nationalité',
      },
      residencePermit: {
        required: 'Veuillez indiquer votre titre de permis de séjour',
      },
      driverLicenceSinceYear: {
        required: 'Veuillez indiquer l\´année depuis laquelle vous êtes ',
        min: 'Veuillez indiquer l\´année depuis laquelle vous êtes ',
        between: 'Le détenteur doit être âgé d\´au moins 18 ans au moment de l\´inspection.',
      },
      agentEmail: {
        required: 'Veuillez indiquer votre adresse d\´email d\´intérmédiaire',
      },
      customerDocuments: {
        required: 'Veuillez indiquer le mode d\´envoi du document',
      },
      gender: {
        required: 'Veuillez indiquer votre titre',
      },
      firstName: {
        required: 'Veuillez indiquer votre prénom',
      },
      lastName: {
        required: 'Veuillez indiquer votre nom de famille',
      },
      street: {
        required: 'Veuillez indiquer votre rue',
      },
      houseNumber: {
        required: 'Veuillez indiquer votre numéro de rue',
      },
      zip: {
        required: 'Veuillez indiquer votre code postale',
        digits: 'Veuillez entrer un code postal à 4 chiffres.',
        validate_zipcode: 'Veuillez entrer un code postal valide.',
      },
      city: {
        required: 'Veuillez indiquer votre lieu de résidence',
      },
      email: {
        required: 'Veuillez indiquer votre adresse e-mail',
        email: 'Veuillez entrer une adresse e-mail valide.',
        validate_email: 'Veuillez entrer une adresse e-mail valide.',
        umlaut_email: "L'adresse e-mail n'est pas valide, elle ne doit pas contenir de ä, ö ou ü.",
      },
      age: {
        required: 'Veuillez indiquer votre âge',
        validate_ageOrYear_16: 'Veuillez indiquer un âge compris entre 16 et 99 ans.',
        validate_ageOrYear_18: 'Veuillez indiquer un âge compris entre 18 et 99 ans.',
      },
      nationalitySwiss: {
        required: 'Veuillez indiquer votre nationalité',
      },
      phone: {
        required: "Vous avez opté pour un modèle de facturation avec tracking (FlexDrive ou BonusDrive). Veuillez indiquer le numéro de téléphone portable du smartphone sur lequel vous souhaitez installer l'application de suivi des habitudes de conduite.",
        validate_mobile_phone: 'Vous avez opté pour un modèle de facturation avec tracking (FlexDrive ou BonusDrive). Nous avons besoin du numéro de téléphone mobile du smartphone sur lequel vous souhaitez installer l\'application de suivi du comportement de conduite. Le numéro indiqué ne semble pas être un numéro de portable (valide).',
        validate_phone: 'Veuillez vérifier votre saisie. Le numéro de téléphone doit comporter entre 8 et 13 chiffres. Le numéro ne doit pas être indiqué.',
      },
      dateOfBirth: {
        required: 'Veuillez indiquer votre date de naissance',
        date_format: 'Veuillez entrer la date dans le format suivant : JJ.MM.AAAA',
        validate_ageMin: 'Vous avez entré votre âge dans la première étape. Vous ne pouvez pas être plus jeune que l\´âge indiqué précédemment.',
        validate_ageMax: 'Vous avez entré votre âge dans la première étape. Vous ne pouvez pas être plus âgé que l\´âge que vous avez indiqué précédemment.',
      },
      startOfInsurance: {
        required: 'Veuillez indiquer la date d\´entrée en vigueur de l\´assurance',
        after: 'La date que vous avez saisie est dans le passé. Veuillez entrer une date du jour.',
        before: 'Veuillez indiquer une date qui se situe dans les 12 prochains mois.',
        date_format: 'Veuillez entrer la date dans le format suivant : JJ.MM.AAAA',
      },
      initialRegistrationYear: {
        required: 'Veuillez indiquer l\´année de la première mise en circulation',
      },
      brand: {
        required: 'Veuillez d\´abord sélectionner la marque, puis le modèle.',
      },
      model: {
        required: 'Veuillez sélectionner le modèle en plus de la marque.',
      },
      typenumber: {
        required: 'Véhicule non trouvé. Veuillez vérifier votre saisie ou utiliser la recherche de véhicule.',
        digits: 'Véhicule non trouvé. Veuillez vérifier votre saisie ou utiliser la recherche de véhicule.',
      },
      typeCertificateNumber: {
        required: 'Veuillez indiquer le numéro de réception par type',
        regex: 'Veuillez vérifier le numéro de réception par type (6 chiffres)',
      },
      licencePlate: {
        required: 'Veuillez indiquer votre numéro de plaque',
        digits: 'Veuillez vérifier la plaque d\´immatriculation.',
        regex: 'Veuillez vérifier la plaque d\´immatriculation.',
        between: 'Le numéro de plaque de contrôle doit être compris entre 1 et 99999999.',
      },
      partially_comprehensive: {
        park_damage_deductible: {
          max_value: 'La franchise doit être inférieure d\´au moins 100 CHF que la franchise en cas de collision. Pour une franchise en cas de collision de CHF 0, la franchise pour les dommages de stationnement doit également être de CHF 0.',
        },
        personal_effects_coverage: {
          in: 'Seuls les montants de CHF 0, CHF 1\´000, CHF 2\´000, CHF 3\´000, CHF 4\´000 ou CHF 5\´000 sont autorisés.',
        },
        protective_clothing: {
          between: 'La valeur des vêtements de protection doit être comprise entre CHF 0 (= non assuré) et CHF 5\´000.',
        },
      },
      fully_comprehensive: {
        deductible1: {
          min_value: 'La franchise doit être supérieure d\´au moins CHF 100.- que la franchise en cas de dommages de parc',
          between: 'En cas de dommages de stationnements non assurés, la franchise doit se situer entre CHF 0 et CHF 10\´000',
          in: 'Veuillez entrer la valeur en 100 étapes',
        },
        deductible2: {
          in: 'Veuillez entrer la valeur en 100 étapes',
          between: 'En cas de dommages de stationnements non assurés, la franchise doit se situer entre CHF 500 et CHF 10\´000',
        },
      },
      legal: {
        required: 'Pour continuer, veuillez confirmer que vous avez lu et compris les documents ci-dessus.',
      },
      legalAgent: {
        required: 'Pour continuer, veuillez confirmer que le client accepte les documents et conditions qui lui sont applicables et que vous êtes autorisé à conclure le présent contrat.',
      },
      serialNumber: {
        regex: 'Veuillez vérifier le format',
        validate_serial_number: 'Veuillez vérifier si le numéro de matricule que vous avez entré ne contient pas d\´erreurs.',
      },
      youngDriver: {
        validate_driverUnderTwentyfive: 'Vous avez indiqué que vous avez moins de 25 ans, vous ne pouvez donc pas répondre à cette question par la négative.',
      },
    },
  },
  rateListItems: {
    liability: 'Responsabilité civile',
    deductible: 'Franchise CHF&nbsp;{value}',
    partially_comprehensive: 'Casco partielle',
    fully_comprehensive: 'Casco collision',
    gross_negligence: 'Assurance faute grave',
    passenger_accident: 'Assurance-accidents <span>{bundle}</span>',
    '24_assistance': 'Assistance 24h/24 <span>{bundle}</span>',
    surcharges: 'Suppléments',
    daily_termination: 'Droit de résiliation journalier',
    deductiblePersonalEffects: 'Franchise objets transportés',
    replacementValueSupplement: 'Complément valeur temporelle',
    freeGarageChoice: 'Libre choix du garage',
    standStillRisk: 'Risque d\'immobilisation',
    Basis: 'Basic',
    Plus: 'Plus',
    Standard: 'Standard',
    not_covered: 'pas assuré',
    unlimited: 'Illimitée',
    yes: 'Oui',
    no: 'non',
    versicherungssumme: 'Somme d\'assurance',
    protective_clothing: 'Vêtements de protection',
    free_garage: {
      headline: 'Convention de réparation: {value}',
      accordionText: '<p>{free_garage}</p>',
    },
    glass: {
      Basis: 'pas assuré',
      Plus: 'assuré',
    },
    DexCarM: {
      liability: '<p>Somme d‘assurance:<br>CHF&nbsp;{insuarance_sum_value}&nbsp;Mio</p><p>Franchise pour les conducteurs non déclarés jusqu\'à 25 ans<br>+ CHF&nbsp;{value_under_25}</p>',
      partially_comprehensive: '<p>Bris de glace Plus (bloc optique):<br>{glas_package}</p><p>Objets transportés:<br>{personal_effects_coverage}</p>',
      fully_comprehensive: '<p>Assurance parc:<br>{park_damage_value}</p><p>Assurance parc franchise:<br>{park_damage_deductible}</p><p>Franchise casco collision pour les conducteurs non déclarés jusqu\'à 25 ans <br>+ &nbsp;{value_under_25}</p>',
      gross_negligence: '<p>{negligence}</p>',
      passenger_accident: 'Assurance accident Standard',
      '24_assistance': '24h Assistance Basic',
    },
    DexCarL: {
      liability: '<p>Somme d‘assurance:<br>CHF&nbsp;{insuarance_sum_value}&nbsp;Mio</p><p>Franchise pour les conducteurs non déclarés jusqu\'à 25 ans<br>+ CHF&nbsp;{value_under_25}</p>',
      partially_comprehensive: '<p>Bris de glace Plus (bloc optique):<br>{glas_package}</p><p>Objets transportés:<br>{personal_effects_coverage}</p>',
      fully_comprehensive: '<p>Assurance parc:<br>{park_damage_value}</p><p>Assurance parc franchise:<br>{park_damage_deductible}</p><p>Franchise casco collision pour les conducteurs non déclarés jusqu\'à 25 ans <br>+ &nbsp;{value_under_25}</p>',
      gross_negligence: '<p>{negligence}</p>',
      passenger_accident: '<p>Cercle des personnes assurées:<br>tous les occupants</p><p>En cas de décès:<br>{death_benefit}</p><p>En cas d’invalidité:<br>{disability_capital}</p><p>Indemnités journalières:<br>{daily_compensation}</p>',
      '24_assistance': '<p>Remorquage:<br>auprès du garage le plus proche</p><p>Assurer la mobilité, y compris le retour du voyage (remplacement / location de voiture, transport public, taxi, etc.) <br>jusqu’à CHF&nbsp;1&#xFEFF;\´500</p>',
    },
    DexCarXl: {
      liability: '<p>Somme d‘assurance:<br>CHF&nbsp;{insuarance_sum_value}&nbsp;Mio</p><p>Franchise pour les conducteurs non déclarés jusqu\'à 25 ans<br>+ CHF&nbsp;{value_under_25}</p>',
      partially_comprehensive: '<p>Bris de glace Plus (bloc optique):<br>{glas_package}</p><p>Objets transportés:<br>{personal_effects_coverage}</p>',
      fully_comprehensive: '<p>Assurance parc:<br>{park_damage_value}</p><p>Assurance parc franchise:<br>{park_damage_deductible}</p><p>Franchise casco collision pour les conducteurs non déclarés jusqu\'à 25 ans <br>+ &nbsp;{value_under_25}</p>',
      gross_negligence: '<p>{negligence}</p>',
      passenger_accident: '<p>Cercle des personnes assurées:<br>tous les occupants</p><p>En cas de décès:<br>{death_benefit}</p><p>En cas d’invalidité:<br>{disability_capital}</p><p>Indemnités journalières:<br>{daily_compensation}</p>',
      '24_assistance': '<p>Remorquage:<br>auprès du garage de votre choix</p><p>Assurer la mobilité, y compris le retour du voyage (remplacement / location de voiture, transport public, taxi, etc.)<br>jusqu’à CHF 4&#xFEFF;\´000</p>',
    },
    flexDrive: {
      headline: 'FlexDrive',
      accordionText: "Facturation au kilomètre près en fonction des kilomètres réellement parcourus. Le choix entre les modèles de décompte peut être fait sur les pages suivantes «modifier les couvertures » ou à l'étape 3 selon les données du détenteur.",
    },
  },
  billingModels: {
    flex_drive: 'FlexDrive',
    flat_rate: 'BasisDrive',
    bonus_drive: 'BonusDrive',
  },
  billingModelChooser: {
    trackingDrivingBehaviour: 'Suivi du comportement de conduite',
    chooseBillingModel: 'Choisir le modèle de facturation',
    bonusDriveExplanation: '(BasisDrive avec suivi de votre comportement de conduite)',
    headlineInfoText: {
      flex_drive: "<p>La prime totale se compose d'une prime fixe (risques stationnaires (casco partielle)) et de la prime variable (risques roulants (casco collision, responsabilité civile, faute grave)). La prime totale (CAP) est plafonnée (prime annuelle maximale garantie).</p><br><p>Comment est calculé le CAP : Prime fixe par an + primes kilométriques pour 12'000 kilomètres. FlexDrive est facturé mensuellement par carte de crédit.</p><br><p>Les kilomètres parcourus sont déclarés par mois par année d'assurance ainsi que le score (comportement de conduite) via l'application. Le score peut réduire la prime basée sur le kilométrage, mais pas l'augmenter.</p><br><p>Dès que votre contrat a été conclu, vous recevez un SMS et un EMAIL avec les instructions pour télécharger l'APP et vous inscrire. Pour simpego FlexDrive, il faut une application simpego FlexDrive activée. Dès que l'on autorise l'application à surveiller ses trajets, elle s'exécute en arrière-plan. Il n'est pas nécessaire de redémarrer l'application à chaque fois que l'on prend la route ou de faire quelque chose de spécial.</p> <p>Veuillez noter qu’un seul contrat FlexDrive peut être associé à chaque numéro de mobile.</p>",
      bonus_drive: "<p>Dès que votre contrat est signé, vous recevez un SMS et un EMAIL avec les instructions pour télécharger l'APP et vous inscrire.</p><br><p>L'APP simpego FlexDrive est exécutée en arrière-plan afin de suivre votre conduite. Il se peut que vous receviez occasionnellement des messages vous rappelant de laisser le WLAN activé ou de redémarrer l'appli si elle ne fonctionne plus pour une raison quelconque. Votre score de conduite s'affiche lorsque vous avez effectué vos 10 premiers trajets (voir la carte Trip Tracker dans l'appli). Vous pouvez voir la liste de vos trajets précédents. Sur la base de vos performances de conduite, votre score sera mis à jour et affiché sur l'écran principal de l'appli. Nous nous ferons une idée du type de conducteur que vous êtes, nous vous aiderons à vous améliorer et, par-dessus le marché, vous obtiendrez une réduction sur votre assurance.</p>  <p>Veuillez noter qu’un seul contrat BonusDrive peut être associé à chaque numéro de mobile.</p>",
    },
    subline: {
      flex_drive: "FlexDrive est un système de facturation au kilomètre qui permet de ne payer que les kilomètres réellement parcourus. La prime totale se compose d'une <a href=\"https://www.simpego.ch/flexdrive-fr\" target=\"blank\">prime annuelle fixe</a>, d'une <a href=\"https://www.simpego.ch/flexdrive-fr\" target=\"blank\">prime variable</a> (prime par kilomètre) et du <a href=\"https://www.simpego.ch/flexdrive-fr\" target=\"blank\">comportement de conduite</a>. Le comportement au volant est suivi par une application et converti en un score. Celui-ci peut faire baisser la prime à payer effectivement par kilomètre, mais pas l'augmenter. Veuillez noter qu’un seul contrat FlexDrive peut être associé à chaque numéro de mobile.",
      flat_rate: "La prime est fixée par année contractuelle et doit être payée à l'avance. Son montant dépend des risques assurés et de la prestation convenue.",
      bonus_drive: "La prime est fixée par année contractuelle et doit être payée à l'avance. Le montant dépend des risques assurés et de la prestation convenue. Pendant l'année d'assurance, vous pouvez connaître votre bonus et bénéficier ainsi d'un rabais sur votre assurance pour l'année d'assurance suivante. Pour enregistrer votre comportement de conduite dans l’application Simpego et calculer votre bonus, nous avons besoin de votre numéro de mobile. Veuillez noter qu’un seul contrat BonusDrive peut être associé à chaque numéro de mobile.",
    },
    trackingDrivingBehaviourInfoText: "<p>Le suivi du comportement de conduite fait partie intégrante de FlexDrive et BonusDrive.</p><br><p>Le suivi du comportement de conduite nécessite l'application Simpego FlexDrive. Dès que le contrat est signé, vous recevez un SMS et un EMAIL avec les instructions pour télécharger l'APP et vous inscrire. Dès que l'application est autorisée à surveiller les trajets, elle s'exécute en arrière-plan. Il n'est pas nécessaire de redémarrer l'application à chaque fois ou de faire quoi que ce soit de spécial avant de partir. Après l'enregistrement dans l'APP, on reçoit toutes les informations supplémentaires par e-mail.</p>",
  },
  productInfoText: {
    DexCarM: 'Notre prime pour les comparateurs et pour les épargnants. Tout ce dont vous avez besoin en tant que conducteur : Responsabilité, casco partielle et protection contre les collisions.',
    DexCarL: "Notre produit le plus populaire. Bénéficiez d'avantages supérieurs à la moyenne à des primes attrayantes, y compris l'assurance accidents, l’assurance pour faute grave ainsi que l'assistance 24 heures sur 24.",
    DexCarXl: "Les petits tuyaux sur le marché. Notre produit pour ceux qui apprécient une protection illimitée avec des franchises minimales. Les meilleures conditions pour la responsabilité, la casco partielle, la protection contre les collisions, l'assurance accident, l’assurance pour faute grave ainsi que l'assistance 24 heures sur 24.",
    billingModelInfo: "Vous pouvez choisir entre le modèle de facturation BasisDrive, FlexDrive ou BasisDrive avec suivi de votre comportement de conduite. FlexDrive est un système de facturation au kilomètre qui permet de ne payer que pour les kilomètres réellement parcourus. Si la voiture reste au garage ou si l'on se déplace moins, on économise automatiquement de la prime. Et grâce au décompte mensuel, on garde toujours une vue d'ensemble! BonusDrive et FlexDrive ne sont actuellement pas encore calculables pour les motos et les entreprises. <a href=\"https://blog.simpego.ch/fr/modeles-de-facturation-assurance-automobile/\" target=\"blank\">Pour plus d'informations, cliquez ici</a>",
  },
  file: {
    select: 'Sélectionner un fichier',
    clear: 'Effacer le champ de saisie',
  },
}
